<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <h2 class="section-title">{{ title }}</h2>
    <p *ngIf="message">{{ message }}</p>
    
    <ng-content></ng-content>

    <div class="modal-actions">
      <button class="cancel-button" (click)="onCancel()">{{ cancelText }}</button>
      <button 
        class="confirm-button" 
        [class.danger]="confirmType === 'danger'"
        [class.success]="confirmType === 'success'"
        (click)="onConfirm()">
        {{ confirmText }}
      </button>
    </div>
  </div>
</div>
